import { useEffect } from 'react';

import { useGetVersions } from './api/hooks/useGetVersions';
import { STORAGE_KEYS } from './constants';

export const useClearStorageOnMissingVersion = (enabled = true) => {
  const { data, isLoading, error } = useGetVersions(enabled);

  useEffect(() => {
    if (isLoading || error) return;

    const localVersion = localStorage.getItem(STORAGE_KEYS.VERSION);
    const fetchedVersion = data?.version ?? null;

    if (!localVersion || localVersion !== fetchedVersion) {
      if ('caches' in window) {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cacheName => {
            caches.delete(cacheName);
          });
        });
      }

      localStorage.setItem(STORAGE_KEYS.VERSION, fetchedVersion ?? '');
    }
  }, [data, isLoading, error]);
};
